import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function LegalPage({ title, updated, sections, testid }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid={testid} className="min-h-screen">
      <Navbar />
      <section className="relative overflow-hidden pt-36 pb-16">
        <div className="pointer-events-none absolute left-1/2 top-10 h-[300px] w-[500px] -translate-x-1/2 rounded-full bg-white/12 blur-[140px]" />
        <div className="relative mx-auto max-w-4xl px-6 md:px-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-white/75 hover:text-white transition-colors"
          >
            <ArrowLeft size={14} /> Back home
          </Link>
          <h1 className="mt-8 font-display text-4xl font-extrabold leading-none tracking-tighter text-white md:text-6xl">
            {title}
          </h1>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.15em] text-white/65">
            Last updated: {updated}
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-32 md:px-12">
        <div className="space-y-12">
          {sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-2xl font-bold tracking-tight text-white">
                {i + 1}. {s.heading}
              </h2>
              <div className="mt-4 space-y-4 text-white/75 leading-relaxed">
                {s.body.map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-2xl border border-white/10 bg-[#0a0a0a] p-6 text-white/75">
          Questions about this policy? Reach us on WhatsApp or call{" "}
          <span className="text-white">+91 93167 80441</span>, or email through our{" "}
          <Link to="/#contact" className="text-white hover:underline">contact form</Link>. Adinvo, Mumbai, India.
        </div>
      </section>
      <Footer />
    </div>
  );
}
